<div class="contest-list__wrapper">
    <h1 class="contest-list__title">{{ "contest.list_title" | translate }}</h1>
    <app-contest-card *ngFor="let contest of contests"
                      [contest]="contest">
    </app-contest-card>
</div>